// extracted by mini-css-extract-plugin
module.exports = {"tokensVotersWrapper":"styles_tokensVotersWrapper__ZOAB7","voterInfo":"styles_voterInfo__3Qlsy","name":"styles_name__3_8aX","avatar":"styles_avatar__2mEMj"};